import { render } from "./PhaseBlock.vue?vue&type=template&id=d5fdc118"
import script from "./PhaseBlock.vue?vue&type=script&lang=js"
export * from "./PhaseBlock.vue?vue&type=script&lang=js"

import "./PhaseBlock.vue?vue&type=style&index=0&id=d5fdc118&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__